import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { AnimatePresence, motion } from 'motion/react'
import type { PropsWithChildren, ReactElement } from 'react'
import { column, columnIcon, columnTitle } from './KanbanColumn.css'

export const KanbanColumn = ({
  isSpaced,
  className,
  title,
  icon,
  children
}: PropsWithChildren<{
  isSpaced?: boolean
  className?: string
  title: string | ReactElement
  icon?: IconDefinition
}>): ReactElement => {
  return (
    <motion.div
      className={clsx(className, column)}
      initial={{ opacity: 0, x: -20, maxWidth: 0, minWidth: 0, marginRight: 0 }}
      animate={{
        opacity: 1,
        x: 0,
        minWidth: '280px',
        maxWidth: '999px',
        marginRight: isSpaced ? 17 : 0
      }}
      exit={{ opacity: 0, x: -20, maxWidth: 0, minWidth: 0, marginRight: 0 }}
    >
      <h2 className={columnTitle}>
        {icon && (
          <span className={columnIcon}>
            <FontAwesomeIcon icon={icon} />
          </span>
        )}
        {title}
      </h2>
      <AnimatePresence>{children}</AnimatePresence>
    </motion.div>
  )
}
